export const useAppDomainConfig = () =>
  process.env.REACT_APP_DEFAULT_DOMAIN
    ? process.env.REACT_APP_DEFAULT_DOMAIN
    : window.location.hostname.split(".")[0];
